// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Payment Mode Drawer ──────────────────────────────────── */
.pm-drawer-paper {
  width: 480px !important;
  max-width: 100vw !important;
  box-shadow: -4px 0 32px rgba(0, 0, 0, 0.12) !important;
}

.pm-drawer-root {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f8fafc;
  font-family: "Outfit", "Inter", sans-serif;
}

/* ── Header ───────────────────────────────────────────────── */
.pm-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 18px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.pm-drawer-header-title {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.01em;
}

.pm-drawer-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #64748b;
  transition: background-color 0.15s ease;
  flex-shrink: 0;
}

.pm-drawer-close-btn:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

.pm-drawer-close-btn svg {
  width: 18px;
  height: 18px;
  pointer-events: none;
}

/* ── Body ─────────────────────────────────────────────────── */
.pm-drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pm-drawer-body::-webkit-scrollbar {
  width: 6px;
}
.pm-drawer-body::-webkit-scrollbar-track {
  background: transparent;
}
.pm-drawer-body::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 10px;
}

/* ── Main Status Card ─────────────────────────────────────── */
.pm-status-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.pm-status-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 8px;
  gap: 12px;
}

.pm-status-card-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  flex: 1;
}

.pm-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
  letter-spacing: 0.01em;
}

.pm-status-badge-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.pm-status-badge.offline {
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

.pm-status-badge.offline .pm-status-badge-dot {
  background-color: #dc2626;
}

.pm-status-badge.online {
  background: #f0fdf4;
  color: #16a34a;
  border: 1px solid #bbf7d0;
}

.pm-status-badge.online .pm-status-badge-dot {
  background-color: #16a34a;
}

.pm-status-card-desc {
  font-size: 14px;
  color: #64748b;
  margin: 0 0 20px;
  line-height: 1.5;
}

/* ── Switch Option Inner Card ─────────────────────────────── */
.pm-switch-option-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.pm-switch-option-info {
  flex: 1;
}

.pm-switch-option-label {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin: 0 0 4px;
}

.pm-switch-option-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 4px;
}

.pm-switch-option-desc {
  font-size: 13px;
  color: #64748b;
  margin: 0;
  line-height: 1.4;
}

.pm-switch-btn {
  padding: 10px 20px;
  border-radius: 10px;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  font-family: "Outfit", "Inter", sans-serif;
  transition: opacity 0.15s ease, transform 0.1s ease;
  flex-shrink: 0;
}

.pm-switch-btn:hover:not(:disabled) {
  opacity: 0.88;
  transform: translateY(-1px);
}

.pm-switch-btn:active:not(:disabled) {
  transform: translateY(0);
}

.pm-switch-btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  background: #cbd5e1 !important;
  color: #64748b !important;
}

.pm-switch-btn.to-online {
  background: #2563eb;
  color: #ffffff;
}

.pm-switch-btn.to-offline {
  background: #0f172a;
  color: #ffffff;
}

/* ── Manager Auth Card ────────────────────────────────────── */
.pm-auth-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: pm-slide-in 0.25s ease;
}

@keyframes pm-slide-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ── Field Label ──────────────────────────────────────────── */
.pm-field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pm-field-label {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin: 0;
}

/* ── Custom Manager Select Dropdown ──────────────────────── */
.pm-custom-select-wrapper {
  position: relative;
  width: 100%;
}

.pm-custom-select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  background-color: #ffffff;
  font-size: 14px;
  font-family: "Outfit", "Inter", sans-serif;
  cursor: pointer;
  transition: border-color 0.15s ease, border-radius 0.15s ease;
  box-sizing: border-box;
  text-align: left;
  gap: 8px;
  color: #1a1a2e;
}

/* When open: square bottom corners so it merges flush with the dropdown */
.pm-custom-select-trigger.open {
  border-color: #d1d5db;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-color: transparent;
  box-shadow: none;
}

.pm-custom-select-trigger:focus {
  outline: none;
}

.pm-select-placeholder {
  color: #6b7280;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
}

.pm-select-value {
  color: #111827;
  font-weight: 500;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pm-select-chevron {
  flex-shrink: 0;
  color: #6b7280;
  transition: transform 0.2s ease;
}

.pm-select-chevron.rotated {
  transform: rotate(180deg);
}

/* Dropdown panel — flush below the trigger, same width */
.pm-custom-select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border: 1.5px solid #d1d5db;
  border-top: none;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.10);
  z-index: 9999;
  overflow: hidden;
  max-height: calc(4 * 46px);
  overflow-y: auto;
  animation: pm-dropdown-in 0.12s ease;
}

@keyframes pm-dropdown-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.pm-custom-select-dropdown::-webkit-scrollbar {
  width: 4px;
}
.pm-custom-select-dropdown::-webkit-scrollbar-track {
  background: transparent;
}
.pm-custom-select-dropdown::-webkit-scrollbar-thumb {
  background-color: #d1d5db;
  border-radius: 10px;
}

/* All options */
.pm-custom-select-option {
  padding: 11px 16px;
  font-size: 14px;
  font-family: "Outfit", "Inter", sans-serif;
  color: #111827;
  cursor: pointer;
  transition: background-color 0.1s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 46px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
}

.pm-custom-select-option:hover {
  background-color: #f0f9ff;
}

/* Selected option highlight (matches image: solid light blue bg, bold dark text) */
.pm-custom-select-option.pm-selected {
  background-color: #cce8fb;
  color: #111827;
  font-weight: 400;
}

/* First "Select manager" placeholder row — light blue + bold, exactly like the image */
.pm-custom-select-option.placeholder-option {
  background-color: #cce8fb;
  color: #111827;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  border-bottom: none;
}

.pm-option-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ── PIN Input ────────────────────────────────────────────── */
.pm-pin-input {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  color: #0f172a;
  font-family: "Outfit", "Inter", sans-serif;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;
  background-color: #ffffff;
}

.pm-pin-input::placeholder {
  color: #94a3b8;
}

.pm-pin-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

/* ── Auth Fields Row ──────────────────────────────────────── */
.pm-auth-fields-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

/* ── Auth Action Buttons ──────────────────────────────────── */
.pm-auth-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 4px;
}

.pm-auth-btn {
  padding: 12px 16px;
  border-radius: 10px;
  border: 1.5px solid #e2e8f0;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: "Outfit", "Inter", sans-serif;
  transition: all 0.15s ease;
}

.pm-auth-btn.cancel {
  background: #ffffff;
  color: #475569;
}

.pm-auth-btn.cancel:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.pm-auth-btn.confirm {
  background: #2563eb;
  color: #ffffff;
  border-color: #2563eb;
}

.pm-auth-btn.confirm:hover:not(:disabled) {
  background: #1d4ed8;
  border-color: #1d4ed8;
}

.pm-auth-btn.confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pm-auth-btn.confirm.loading {
  opacity: 0.75;
  cursor: wait;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/managerAuth/index.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA,gEAAgE;AAChE;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,OAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,mDAAmD;EACnD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;AACX;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,0CAA0C;EAC1C,eAAe;EACf,6DAA6D;EAC7D,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;EACR,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;EAChC,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mFAAmF;AACnF;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,uFAAuF;AACvF;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,0CAA0C;EAC1C,0DAA0D;EAC1D,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd","sourcesContent":["/* ── Payment Mode Drawer ──────────────────────────────────── */\n.pm-drawer-paper {\n  width: 480px !important;\n  max-width: 100vw !important;\n  box-shadow: -4px 0 32px rgba(0, 0, 0, 0.12) !important;\n}\n\n.pm-drawer-root {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background-color: #f8fafc;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n/* ── Header ───────────────────────────────────────────────── */\n.pm-drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px 18px;\n  background: #ffffff;\n  border-bottom: 1px solid #e2e8f0;\n  flex-shrink: 0;\n}\n\n.pm-drawer-header-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.pm-drawer-close-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: #64748b;\n  transition: background-color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.pm-drawer-close-btn:hover {\n  background-color: #f1f5f9;\n  color: #0f172a;\n}\n\n.pm-drawer-close-btn svg {\n  width: 18px;\n  height: 18px;\n  pointer-events: none;\n}\n\n/* ── Body ─────────────────────────────────────────────────── */\n.pm-drawer-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.pm-drawer-body::-webkit-scrollbar {\n  width: 6px;\n}\n.pm-drawer-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n.pm-drawer-body::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1;\n  border-radius: 10px;\n}\n\n/* ── Main Status Card ─────────────────────────────────────── */\n.pm-status-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 20px;\n  padding: 24px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n}\n\n.pm-status-card-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  gap: 12px;\n}\n\n.pm-status-card-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n  flex: 1;\n}\n\n.pm-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 12px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n  flex-shrink: 0;\n  letter-spacing: 0.01em;\n}\n\n.pm-status-badge-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.pm-status-badge.offline {\n  background: #fef2f2;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n}\n\n.pm-status-badge.offline .pm-status-badge-dot {\n  background-color: #dc2626;\n}\n\n.pm-status-badge.online {\n  background: #f0fdf4;\n  color: #16a34a;\n  border: 1px solid #bbf7d0;\n}\n\n.pm-status-badge.online .pm-status-badge-dot {\n  background-color: #16a34a;\n}\n\n.pm-status-card-desc {\n  font-size: 14px;\n  color: #64748b;\n  margin: 0 0 20px;\n  line-height: 1.5;\n}\n\n/* ── Switch Option Inner Card ─────────────────────────────── */\n.pm-switch-option-card {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 16px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.pm-switch-option-info {\n  flex: 1;\n}\n\n.pm-switch-option-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #94a3b8;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin: 0 0 4px;\n}\n\n.pm-switch-option-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 4px;\n}\n\n.pm-switch-option-desc {\n  font-size: 13px;\n  color: #64748b;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.pm-switch-btn {\n  padding: 10px 20px;\n  border-radius: 10px;\n  border: none;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  transition: opacity 0.15s ease, transform 0.1s ease;\n  flex-shrink: 0;\n}\n\n.pm-switch-btn:hover:not(:disabled) {\n  opacity: 0.88;\n  transform: translateY(-1px);\n}\n\n.pm-switch-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.pm-switch-btn:disabled {\n  opacity: 0.5 !important;\n  cursor: not-allowed !important;\n  background: #cbd5e1 !important;\n  color: #64748b !important;\n}\n\n.pm-switch-btn.to-online {\n  background: #2563eb;\n  color: #ffffff;\n}\n\n.pm-switch-btn.to-offline {\n  background: #0f172a;\n  color: #ffffff;\n}\n\n/* ── Manager Auth Card ────────────────────────────────────── */\n.pm-auth-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 20px;\n  padding: 24px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  animation: pm-slide-in 0.25s ease;\n}\n\n@keyframes pm-slide-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ── Field Label ──────────────────────────────────────────── */\n.pm-field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.pm-field-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #94a3b8;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin: 0;\n}\n\n/* ── Custom Manager Select Dropdown ──────────────────────── */\n.pm-custom-select-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.pm-custom-select-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 10px 14px;\n  border: 1.5px solid #d1d5db;\n  border-radius: 10px;\n  background-color: #ffffff;\n  font-size: 14px;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  cursor: pointer;\n  transition: border-color 0.15s ease, border-radius 0.15s ease;\n  box-sizing: border-box;\n  text-align: left;\n  gap: 8px;\n  color: #1a1a2e;\n}\n\n/* When open: square bottom corners so it merges flush with the dropdown */\n.pm-custom-select-trigger.open {\n  border-color: #d1d5db;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-color: transparent;\n  box-shadow: none;\n}\n\n.pm-custom-select-trigger:focus {\n  outline: none;\n}\n\n.pm-select-placeholder {\n  color: #6b7280;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 400;\n}\n\n.pm-select-value {\n  color: #111827;\n  font-weight: 500;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pm-select-chevron {\n  flex-shrink: 0;\n  color: #6b7280;\n  transition: transform 0.2s ease;\n}\n\n.pm-select-chevron.rotated {\n  transform: rotate(180deg);\n}\n\n/* Dropdown panel — flush below the trigger, same width */\n.pm-custom-select-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: #ffffff;\n  border: 1.5px solid #d1d5db;\n  border-top: none;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.10);\n  z-index: 9999;\n  overflow: hidden;\n  max-height: calc(4 * 46px);\n  overflow-y: auto;\n  animation: pm-dropdown-in 0.12s ease;\n}\n\n@keyframes pm-dropdown-in {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.pm-custom-select-dropdown::-webkit-scrollbar {\n  width: 4px;\n}\n.pm-custom-select-dropdown::-webkit-scrollbar-track {\n  background: transparent;\n}\n.pm-custom-select-dropdown::-webkit-scrollbar-thumb {\n  background-color: #d1d5db;\n  border-radius: 10px;\n}\n\n/* All options */\n.pm-custom-select-option {\n  padding: 11px 16px;\n  font-size: 14px;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  color: #111827;\n  cursor: pointer;\n  transition: background-color 0.1s ease;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-height: 46px;\n  display: flex;\n  align-items: center;\n  background-color: #ffffff;\n}\n\n.pm-custom-select-option:hover {\n  background-color: #f0f9ff;\n}\n\n/* Selected option highlight (matches image: solid light blue bg, bold dark text) */\n.pm-custom-select-option.pm-selected {\n  background-color: #cce8fb;\n  color: #111827;\n  font-weight: 400;\n}\n\n/* First \"Select manager\" placeholder row — light blue + bold, exactly like the image */\n.pm-custom-select-option.placeholder-option {\n  background-color: #cce8fb;\n  color: #111827;\n  font-weight: 700;\n  font-style: normal;\n  font-size: 14px;\n  border-bottom: none;\n}\n\n.pm-option-name {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ── PIN Input ────────────────────────────────────────────── */\n.pm-pin-input {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #0f172a;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-sizing: border-box;\n  background-color: #ffffff;\n}\n\n.pm-pin-input::placeholder {\n  color: #94a3b8;\n}\n\n.pm-pin-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n/* ── Auth Fields Row ──────────────────────────────────────── */\n.pm-auth-fields-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n/* ── Auth Action Buttons ──────────────────────────────────── */\n.pm-auth-actions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-top: 4px;\n}\n\n.pm-auth-btn {\n  padding: 12px 16px;\n  border-radius: 10px;\n  border: 1.5px solid #e2e8f0;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  transition: all 0.15s ease;\n}\n\n.pm-auth-btn.cancel {\n  background: #ffffff;\n  color: #475569;\n}\n\n.pm-auth-btn.cancel:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.pm-auth-btn.confirm {\n  background: #2563eb;\n  color: #ffffff;\n  border-color: #2563eb;\n}\n\n.pm-auth-btn.confirm:hover:not(:disabled) {\n  background: #1d4ed8;\n  border-color: #1d4ed8;\n}\n\n.pm-auth-btn.confirm:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pm-auth-btn.confirm.loading {\n  opacity: 0.75;\n  cursor: wait;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
